import styled, { css } from 'styled-components';

export const StyledAlert = styled.div`
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  align-items: center;
  font-size: var(--font-size-sm);
  line-height: calc(var(--font-size-sm) + 0.3125rem);
  @media (min-width: 768px) {
    padding: 1rem 3.9375rem 1rem 1rem;
  }
  ${({ $type }) =>
    $type === 'success' &&
    css`
      color: var(--success);
      background: rgba(54, 205, 120, 0.12);
    `}

  ${({ $type }) =>
    $type === 'info' &&
    css`
      color: var(--info);
      background: var(--info);
      background: rgba(0, 153, 255, 0.12);
    `}

    ${({ $type }) =>
    $type === 'error' &&
    css`
      color: var(--danger);
      background: rgba(229, 72, 77, 0.12);
    `}
    ${({ $type }) =>
    $type === 'warning' &&
    css`
      color: var(--warning);
      background: rgba(255, 212, 69, 0.12);
    `}
`;

export const Message = styled.p`
  color: inherit;
  margin: 0;
`;
